(function($) {
    $(document).ready(function() {
        const MAX_QTY = 3;
        const cartNotification = document.querySelector('cart-notification');

        $('[data-sample-box]').each(function() {
            const $box = $(this);
            const productId = $box.data('product-id');
            const $form = $box.find('.s-free-product__box-form');
            const $qtyInput = $box.find('.c-quantity__input');
            const $addBtn = $box.find('[name="add"]');
            const $minusBtn = $box.find('[name="minus"]');
            const $plusBtn = $box.find('[name="plus"]');
            const $quantityInput = $box.find('quantity-input');
            let cartQty = parseInt($quantityInput.attr('data-sample-cart-qty')) || 0;

            function getRemaining() {
                return MAX_QTY - cartQty;
            }

            function updateUI() {
                const currentVal = parseInt($qtyInput.val()) || 1;
                const remaining = getRemaining();

                if (remaining <= 0) {
                    $addBtn.attr('disabled', 'disabled');
                    $plusBtn.attr('disabled', 'disabled');
                    $minusBtn.attr('disabled', 'disabled');
                    $qtyInput.attr('readonly', true);
                } else {
                    $addBtn.removeAttr('disabled');
                    $qtyInput.removeAttr('readonly');

                    if (currentVal >= remaining) {
                        $plusBtn.attr('disabled', 'disabled');
                    } else {
                        $plusBtn.removeAttr('disabled');
                    }

                    if (currentVal <= 1) {
                        $minusBtn.attr('disabled', 'disabled');
                    } else {
                        $minusBtn.removeAttr('disabled');
                    }
                }
            }

            $qtyInput.on('change', function() {
                const remaining = getRemaining();
                let val = parseInt($(this).val()) || 1;
                if (remaining <= 0) {
                    val = 0;
                } else if (val > remaining) {
                    val = remaining;
                }
                if (val < 1 && remaining > 0) val = 1;
                $(this).val(val);
                updateUI();
            });

            // Form submit
            $form.on('submit', function(e) {
                e.preventDefault();
                const qty = parseInt($qtyInput.val()) || 0;
                if (qty <= 0 || getRemaining() <= 0) return;

                const variantId = $form.find('input[name="id"]').val();
                $addBtn.attr('disabled', 'disabled');
                $addBtn.addClass('loading');

                const formData = new FormData();
                formData.append('id', variantId);
                formData.append('quantity', qty);
                formData.append('sections', cartNotification.getSectionsToRender().map(function(s) { return s.id; }));
                formData.append('sections_url', window.location.pathname);

                const config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];
                config.body = formData;

                fetch(routes.cart_add_url, config)
                    .then(function(response) { return response.json(); })
                    .then(function(response) {
                        if (response.status) {
                            console.error(response.description);
                            $addBtn.removeAttr('disabled');
                            $addBtn.removeClass('loading');
                            return;
                        }

                        cartQty += qty;
                        $quantityInput.attr('data-sample-cart-qty', cartQty);
                        $qtyInput.val(1);
                        updateUI();
                        $addBtn.removeClass('loading');

                        if (response.sections) {
                            cartNotification.renderContents(response);
                        }

                        document.dispatchEvent(new CustomEvent('sample:cart-updated', {
                            detail: { productId: productId, cartQty: cartQty }
                        }));
                    })
                    .catch(function(err) {
                        console.error(err);
                        $addBtn.removeAttr('disabled');
                        $addBtn.removeClass('loading');
                    });
            });

            document.addEventListener('sample:cart-updated', function(e) {
                if (e.detail.productId === productId) {
                    cartQty = e.detail.cartQty;
                    $quantityInput.attr('data-sample-cart-qty', cartQty);
                    updateUI();
                }
            });

            document.addEventListener('qty.refresh', function(event) {
                if (!event.detail) return;
                let newQty = 0;
                event.detail.forEach(function(item) {
                    if (String(item.product_id) === String(productId)) {
                        newQty += parseInt(item.quantity) || 0;
                    }
                });
                cartQty = newQty;
                $quantityInput.attr('data-sample-cart-qty', cartQty);
                updateUI();
            });

            updateUI();
        });
    });
})(jQuery);
